<template>
  <div class="error-404-view">
    <div class="container">
      <div class="title-error-view col-12">
        <h1 class="col-12">Ops! Página não encontrada.</h1>
        <p class="col-12">
          A página que você procura não foi encontrada ou não existe.
        </p>
      </div>
      <div class="imagem-error-view col-12 my-2">
        <img
          alt="Página não encontrada"
          src="@/assets/images/pagina-nao-encontrada.svg"
        />
      </div>
      <div class="description-error-view col-12">
        <p>Aproveite este momento pra fazer uma pausa e tomar um café!</p>
      </div>
    </div>
    <Contact />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Contact from '@/components/Molecules/Contact.vue'

  export default defineComponent({
    name: 'Error404View',
    components: {
      Contact,
    },
  })
</script>
